export default __webpack_public_path__ + "static/media/gov.077648f9.svg";